import { Message } from "../store/chatStore";

export const  getLastMessage = (chatId: string , messages: Record<string, Message[]>,
  userId: string) => {
  const chatMessages = messages[chatId];
  if (!chatMessages || chatMessages.length === 0) {
    return { content: "", timestamp: "", unReadMessages: 0 };
  }

  let lastMessage = chatMessages[0];
  let unReadMessages = 0;

  for (const msg of chatMessages) {
    // Contar mensagens não lidas
    if (msg.status === "delivered" && msg.senderId !== userId) {
      unReadMessages++;
    }

    // Encontrar a mais recente
    if (new Date(msg.timestamp) > new Date(lastMessage.timestamp)) {
      lastMessage = msg;
    }
  }

  // Determinar conteúdo textual do preview
  let content = "";
  if (lastMessage.type === "image") content = "Imagem";
  else if (lastMessage.type === "pdf") content = "Arquivo";
  else if (lastMessage.type === "audio/webm") content = "Áudio";
  else if (lastMessage.type === "call") content = "Ligação";
  else if (lastMessage.viewOnce) content = "Visualização única";
  else if (typeof lastMessage.content === "string") content = lastMessage.content;

  return {
    content,
    timestamp: lastMessage.timestamp,
    unReadMessages,
  };
};